import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export async function getProfileDetail() {
    try {
        const token =
            typeof window !== 'undefined' ? localStorage.getItem('token') : null;
        const res = await axios.get(`${API_BASE}/api/associates/profileDetail`, {
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        });
        return res.data;
    } catch (error) {
        const message = error?.response?.data?.message || error?.message || 'Failed to load profile';
        throw new Error(message);
    }
}

export async function updateProfile(payload) {
    try {
        const token =
            typeof window !== 'undefined' ? localStorage.getItem('token') : null;
        const isFormData = payload instanceof FormData;
        const headers = {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        };
        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }

        const res = await axios.put(`${API_BASE}/api/associates/updateProfile`, payload, {
            headers,
        });
        return res.data;
    } catch (error) {
        if (error?.response?.data) throw error.response.data;
        throw new Error(error?.message || 'Failed to update profile');
    }
}

export async function sendPasswordOTP(payload) {
    try {
        const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
        const res = await axios.post(`${API_BASE}/api/change-password/send-otp`, payload, {
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        });
        return res.data;
    } catch (error) {
        if (error?.response?.data) throw error.response.data;
        throw new Error(error?.message || 'Failed to send OTP');
    }
}

export async function verifyPasswordOTP(payload) {
    try {
        const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
        const res = await axios.post(`${API_BASE}/api/change-password/verify-otp`, payload, {
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        });
        return res.data;
    } catch (error) {
        if (error?.response?.data) throw error.response.data;
        throw new Error(error?.message || 'Failed to verify OTP');
    }
}

export default {
    getProfileDetail,
    updateProfile,
    sendPasswordOTP,
    verifyPasswordOTP,
};
